import { Calculator2022Controller } from "../../../controllers";
import { ComponentBase } from "../../_ComponentBase";

/**
 * The **CalcUsecase** is the 2022 version of the calculator (Calc) that supports
 * usecases: customizations to user interfaces and logic using HTML and JavaScript.
 * It is expected to eventually replace the old Calc component.
 *
 * The component provides functionality for:
 *
 * 1. Selecting the Employment relation / Worker to the calculation (employer if the current user is Worker)
 * 2. Selecting the usecase if one is not provided in the URI.
 * 3. Defining the Worktime information: Period, Absences and holidays.
 * 4. Defining the calculation rows: salary, expences, benefits, deductions etc.
 * 5. Showing the results as charts and reports.
 * 6. Starting the payment process
 *
 * Controllers are defined in **salaxy.ng1.controllers**. Most of the functionality comes from Calculator2022Controller.
 * The view (html) can be modified using the usecase view mechanism.
 * @example
 * ```html
 * <salaxy-calc-usecase model="'new'"></salaxy-calc-usecase>
 * ```
 */
export class CalcUsecase extends ComponentBase {

   /**
    * The following component properties (attributes in HTML) are bound to the Controller.
    * For detailed functionality, refer to [controller](#controller) implementation.
    */
    public bindings = Calculator2022Controller.crudBindings;

    /** Uses the Calculator2022Controller */
    public controller = Calculator2022Controller;

    /** The default template for the component. */
    public defaultTemplate = "salaxy-components/calc/2022/CalcUsecase.html";

}
